import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import { Icon } from "../icons/Icon";

/** Input de búsqueda del sistema: icono + input + atajo (kbd). */
export function SearchInput({ shortcut, style, className, inputRef, ...input }: { shortcut?: ReactNode | undefined; style?: React.CSSProperties | undefined; className?: string | undefined; inputRef?: Ref<HTMLInputElement> | undefined } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className={className ? `sk-inputwrap ${className}` : "sk-inputwrap"} style={style}>
      <Icon name="search" />
      <input className="sk-input" ref={inputRef} {...input} />
      {shortcut !== undefined && <span className="sk-kbd">{shortcut}</span>}
    </div>
  );
}
export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="sk-toolbar">{children}</div>;
}
